import { AnnotationsScreen } from '../correspondenceModule/AnnotationsScreen';

export const AnnotationsManagmentScreen = () => {
    return (
        <div>
            <AnnotationsScreen />
        </div>
    )
}
